import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { AuthMembership, AuthSession } from '@/features/auth/types'

interface AuthSessionState {
  session: AuthSession | null
  initialized: boolean
  setSession: (session: AuthSession) => void
  setInitialized: (initialized: boolean) => void
  clearSession: () => void
  updateMembership: (membership: AuthMembership | null) => void
  isAuthenticated: () => boolean
}

export const useAuthSessionStore = create<AuthSessionState>()(
  persist(
    (set, get) => ({
      session: null,
      initialized: false,
      setSession: (session) => set({ session }),
      setInitialized: (initialized) => set({ initialized }),
      clearSession: () => set({ session: null }),
      updateMembership: (membership) =>
        set((state) => {
          if (!state.session || !membership) return state
          return {
            session: {
              ...state.session,
              membership,
            },
          }
        }),
      isAuthenticated: () => Boolean(get().session?.user?.id),
    }),
    {
      name: 'freecut-auth-session',
      partialize: (state) => ({ session: state.session }),
    },
  ),
)

export function hasActiveSession(): boolean {
  return useAuthSessionStore.getState().isAuthenticated()
}